import { useEffect } from "react";
/* eslint-disable no-unused-vars */
import { useSelector } from "react-redux";
import CssBaseline from "@mui/material/CssBaseline";
import { theme, darkTheme } from "./styles/theme";
import "./styles/style.css";
import { ThemeProvider } from "@mui/material/styles";
import ErrorBoundary from "./Components/ErrorBoundary";
// This is needed to initialize i18next
import "./i18n/i18n";
// import { useTranslation } from "react-i18next";

// UI
import {
  selectCurrentLanguage,
  selectDarkMode,
} from "./ducks/app/userSettings/selectors";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterLuxonSafe } from "./AdapterLuxonSafe";
import DragNDropProvider from "./DragNDropProvider";
import { changeLanguage } from "./i18n/i18n";
import DoraRoutes from "./pages/DoraRoutes";
import SocketConnection from "./SocketConnection";
import { LocalizationProvider as L10nProvider, useL10n } from "./l10n";
import VersionBanner from "./Components/VersionBanner";
import SessionChangedBanner from "./Components/SessionChangedBanner";

const LanguageSwitcher = () => {
  const selectedLanguage = useSelector(selectCurrentLanguage);
  useEffect(() => {
    changeLanguage(selectedLanguage);
  }, [selectedLanguage]);
  return null;
};

const MuiLocalizationWrapper = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  const l10n = useL10n();
  return (
    <LocalizationProvider
      dateAdapter={AdapterLuxonSafe as any}
      adapterLocale={l10n.locale}
    >
      {children}
    </LocalizationProvider>
  );
};

export default function App() {
  // const { t } = useTranslation(["dispatching", "translation", "fleet"]);
  const lightTheme = useSelector(selectDarkMode);
  useEffect(() => {
    document.body.setAttribute("data-theme", lightTheme ? "dark" : "light");
  }, [lightTheme]);
  const selectedLanguage = useSelector(selectCurrentLanguage);
  return (
    <ErrorBoundary>
      <LanguageSwitcher />
      <VersionBanner />
      <SessionChangedBanner />
      <DragNDropProvider>
        <ThemeProvider theme={lightTheme ? darkTheme : theme}>
          <CssBaseline />
          <L10nProvider locale={selectedLanguage}>
            <MuiLocalizationWrapper>
              <ErrorBoundary>
                <SocketConnection>
                  <DoraRoutes />
                </SocketConnection>
              </ErrorBoundary>
            </MuiLocalizationWrapper>
          </L10nProvider>
        </ThemeProvider>
      </DragNDropProvider>
    </ErrorBoundary>
  );
}
